/* beautiful-react-hooks version: 0.27.4 */
var safelyParseJson = function safelyParseJson(parseString) {
  try {
    return JSON.parse(parseString);
  } catch (e) {
    return null;
  }
};

export default safelyParseJson;
